import axios from "axios";
import { useQuery, UseQueryOptions } from "react-query";
import { API_CACHE_KEYS, ApiRoutes } from "../constants/apiRoutes";
import { ICustomerQuoteProducts, IQuoteProduct } from "../shared/types";

export const useGetQuoteProducts = (
  options?: UseQueryOptions<IQuoteProduct[], null, IQuoteProduct[]>
) => useQuery<IQuoteProduct[], null, IQuoteProduct[]>(
  API_CACHE_KEYS.PRODUCTS,
  async () => (await axios.get(ApiRoutes.products)).data,
  { ...options, placeholderData: [], retry: 0 }
);

export const useGetCustomerQuoteProducts = (customerGuid?: string) => useQuery<ICustomerQuoteProducts, unknown, ICustomerQuoteProducts>(
  [API_CACHE_KEYS.CUSTOMER_PRODUCTS, customerGuid],
  async () => (await axios.get(ApiRoutes.customerProducts.replace("{customerGuid}", customerGuid!))).data,
  { enabled: Boolean(customerGuid), retry: 0 }
);
